import { connect } from 'react-redux';

import { TThunkDispatch } from '../../types/redux';
import { FOfferType } from '../../utils/category';
import { selectOfferType } from '../../actions/filters';
import { FilterOfferType, IFilterOfferTypeProps } from '../../components/FilterOfferType';

type TFilterOfferTypeDispatchProps = Pick<IFilterOfferTypeProps, 'onSelect'>;

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterOfferTypeDispatchProps {
  return {
    onSelect: (offerType: FOfferType) => dispatch(selectOfferType(offerType)),
  };
}

export const FilterOfferTypeContainer = connect(null, mapDispatchToProps)(FilterOfferType);
